module.exports = __webpack_public_path__ + "static/img/logo.d6d86989.png";